<template>
  <div class="ll-diagram-card-list">
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlDiagramCardList",
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-diagram-card-list";
</style>